export enum SentryIssueScope {
  GraphQLError = 'GraphQL Error',
  GraphQLNetworkError = 'GraphQL Network Error',
  HttpError = 'Http Error',
  ChunkLoadError = 'Chunk Load Error',
  ClientSideError = 'Client Side Error',
  LongScreenLoading = 'Long Screen Loading',
}
